import React from "react";
import { useTranslation } from "src/context/Translations/context";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";

const LovHomePage: React.FC<Omit<IComponentSelect,"options">> = ({
	name,
	control,
	label,
	defaultValue,	
	...rest
}) => {
	const { translate} = useTranslation();
	return (
		<Select
			control={control}
			name={name}
			label={label||translate("Página inicial")}
			defaultValue={defaultValue || ""}
			options={[
				{ value: "1", label: "Dashboard" },
				{ value: "2", label: translate("Painel de Indicadores") },
				{ value: "3", label: translate("Painel de Ações") },
				{ value: "4", label: translate("Matriz de Priorização") },
				{ value: "5", label: translate("Mapas") },
				{ value: "6", label: "Kanban" },
				{ value: "7", label: translate("Painel de Projetos") },
				{ value: "8", label: translate("Painel de Ocorrências") },
				{ value: "9", label: translate("Painel Plano Orçamentário") },
				{ value: "10", label: translate("Painel de Auditorias") }	
			]}
			{...rest}
		/>
	);
};

export default LovHomePage;
